<template>
  <footer class="footer">
    <p class="has-text-centered">
      Copyright &copy; {{ new Date().getFullYear() }} Kevin Chen
    </p>
  </footer>
</template>

<script>
export default {
  name: 'AppFooter'
}
</script>
